import React from "react";
import { Navigate } from "react-router-dom";

const VIEW_TYPE_STORAGE_KEY = "recon_view_type";

const ReconciliationRedirect: React.FC = () => {
    const stored = localStorage.getItem(VIEW_TYPE_STORAGE_KEY);
    const target = stored === "version-1" ? "version-1" : "version-2";

    return (
        <Navigate
            to={`${process.env.PUBLIC_URL}/data-table/reconciliation-automation-${target}`}
            replace
        />
    );
};

export default ReconciliationRedirect;